import React from 'react';
import {
  DefaultNotification,
  IDefaultNotificationProps,
} from '../../DefaultNotification';

function UpdateSubscriptionNotification({
  is_active,
  created_at,
  ...notification
}: IDefaultNotificationProps) {
  return (
    <div className="flex flex-col flex-1">
      {is_active ? (
        <small className="mt-2 font-semibold text-[rgba(59,58,52,0.9)]">
          A assinatura está ativa
        </small>
      ) : (
        <small className="mt-2 font-semibold text-[rgba(59,58,52,0.9)]">
          A assinatura está desativada
        </small>
      )}
      <DefaultNotification
        {...notification}
        is_active={is_active}
        created_at={created_at}
      />
    </div>
  );
}

export default UpdateSubscriptionNotification;
